import { memo, useEffect, useState, useRef, useLayoutEffect } from 'react';
import { usePrevious } from '../../../customHooks/usePrevious';
import { fightSlice } from '../../../store/reducers/FightReducer';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import EnemysAlive from './EnemiesAlive';
import EnemysDead from './EnemiesDead';
import './Enemies.scss'
import { IImages } from '../../../mechanics/characters/Character';

interface IEnemyProps {
    enemyImg: IImages,
    enemyHp: number,
    maxEnemyHp: number,
    enemyIndex: number,
    handleCharacterClick: (value: number) => void
}

const Enemies = ({ enemyImg, enemyHp, maxEnemyHp, enemyIndex, handleCharacterClick }: IEnemyProps) => {
    const widthHpBar = Math.round((enemyHp / maxEnemyHp) * 100)
    const prevHp = usePrevious(enemyHp)
    const takenDamage = prevHp - enemyHp
    const isAlive = enemyHp > 0
    const dispatch = useAppDispatch()
    const { setChoiceActive } = fightSlice.actions
    const ischoiceActive = useAppSelector(state => state.FightReducer.ischoiceActive)

    const handleClick = () => {
        if (ischoiceActive && isAlive) {
            handleCharacterClick(enemyIndex)
            dispatch(setChoiceActive(false))
        }
    }

    const takenDamageContent = () => {
        let content: any = <></>

        if (takenDamage > 0 && !ischoiceActive) {
            content = <span className="player__content-taken-damage">-{takenDamage}</span>
        }

        if (!takenDamage && !ischoiceActive && isAlive) {
            content = <span className="player__content-taken-damage">Miss</span>
        }

        return content
    }

    const choseClassName = ischoiceActive ? '_chose-active' : ''

    return (
        <div className={`enemies__content ${choseClassName}`}
            onClick={handleClick}>
            {isAlive ?
                <EnemysAlive
                    enemyImg={enemyImg}
                    enemyHp={enemyHp}
                    maxEnemyHp={maxEnemyHp}
                    widthHpBar={widthHpBar}
                />
                :
                <EnemysDead
                    maxEnemyHp={maxEnemyHp}
                />
            }
            <span className="player__content-taken-damage enemies"></span>
        </div>
    );
};

export default memo(Enemies);